import React from 'react'

const INVITE_URL = 'https://discord.com/oauth2/authorize?client_id=1142325515575889971&permissions=329639128080&integration_type=0&scope=bot'

function InviteBotButton({ className = '', children = 'Ajouter le bot', ...props }) {
  return (
    <a
      href={INVITE_URL}
      className={className}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Inviter le bot Pokefarm sur Discord"
      {...props}
    >
      {children}
    </a>
  )
}

export default InviteBotButton
